<template>
	<div class="user-manager">
		Code templates
	</div>
</template>

<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

//import Login from '@/components/Login.vue'

export default
{
	name: 'CodeTemplates',

	components:
	{
		
	}
}

</script>